import { GraphQLObjectType, GraphQLNonNull, GraphQLString } from 'graphql'
import { dateTimeType, DateTime } from './date-time-type'

export interface GQLBugTracker {
  readonly name: string
  readonly type: string
  readonly creation: DateTime
  readonly ticketKey: string
  readonly ticketTitle: string
  readonly ticketUrl: string | null
}

export const bugTrackerType = new GraphQLObjectType({
  name: 'BugTracker',
  fields: () => ({
    name: {
      description: 'Bug tracker name',
      type: new GraphQLNonNull(GraphQLString)
    },
    type: {
      description: 'Bug tracker type',
      type: new GraphQLNonNull(GraphQLString)
    },
    creation: {
      description: 'Creation date/time',
      type: new GraphQLNonNull(dateTimeType)
    },
    ticketKey: {
      description: 'Ticket key',
      type: new GraphQLNonNull(GraphQLString)
    },
    ticketTitle: {
      description: 'Ticket title',
      type: new GraphQLNonNull(GraphQLString)
    },
    ticketUrl: {
      description: 'Ticket URL',
      type: GraphQLString
    }
  })
})
